// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2uIv7HMfu56lrpVUmuGCDq","emojiBox":"_2m5XU6KjL9gKJtLzb4qM94","content":"_3CYSpf70fp_pUhnSAch-6L"};